// import { CSSTransition } from 'react-transition-group';
import { useState } from 'react';
import { useEffect } from 'react';
import Counter from './Counter';
import { ABOUT_PAGE } from '../../data/texts';

const CounterNumbersBox = () => {

    const data = ABOUT_PAGE.stats
    
    const [doctors, setDoctors] = useState(0)

    const [articles, setArticles] = useState(0)

    const [medicalField, setmMdicalField] = useState(0)

    const [userSatisfaction, setUserSatisfaction] = useState(0)

    
    useEffect(() => {

        const interval = setInterval(() => {

            if(doctors < data.doctors ){

                setDoctors(doctors+10)

            }

            if(articles < data.articles ){

                setArticles(articles+40)

            }
            if(medicalField < data.specialties ){

                setmMdicalField(medicalField+1)

            }
            if(userSatisfaction < data.users ){

                setUserSatisfaction(userSatisfaction+100)

            }
            else{
                clearInterval(interval)
            }
        },20)
        return () => clearInterval(interval)
        
    },[doctors,articles,medicalField,userSatisfaction])

    return(
        <section className='rounded-[20px] bg-[#858585] p-10  mb-5
        -mt-8 xs:-mt-2 md:-mt-5'>
              <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5'>
                        <Counter
                        number={doctors}
                        title={'پزشک فعال'}
                        />
                        <Counter
                        number={articles}
                        title={'مطالب روز سلامتی و درمان'}
                        />
                        <Counter
                        number={medicalField}
                        title={'تخصص پزشکی'}
                        />
                        <Counter
                        number={userSatisfaction}
                        title={'کاربر رضایتمند'}
                        />

                    </div>
        </section>
    )
}
export default CounterNumbersBox

